import { render } from "./DeputyAudit.vue?vue&type=template&id=178e2954&scoped=true"
import script from "./DeputyAudit.vue?vue&type=script&lang=js"
export * from "./DeputyAudit.vue?vue&type=script&lang=js"

import "./DeputyAudit.vue?vue&type=style&index=0&id=178e2954&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-178e2954"]])

export default __exports__